import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { Billboard, VerticalCard, HorizontalCard, TypeIcon } from 'components/ContentCards';
import PageSection from 'components/PageSection';
import Heading from 'components/Heading';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import { RECOMMENDED_ASSET_THUMBNAIL_SIZE } from 'screens/ThumbnailPreview';
import Wrapper from '../common/Wrapper';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AssetThumbnailPreview(_ref) {
  var asset = _ref.data,
    onClose = _ref.onClose;
  var thumbnailId = asset.thumbnailId,
    id = asset.id,
    name = asset.name,
    description = asset.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var rawType = getContentItemType(asset);
  var icon = getContentItemIconFromType(rawType);
  var type = t(getContentItemTypeTranslationKey(rawType));
  return /*#__PURE__*/_jsxs(Wrapper, {
    id: "preview-asset-modal",
    title: t('thumbnail_preview_item_image_preview', {
      itemName: t('content_type_asset')
    }),
    aspectRatio: "3:2 (".concat(t('thumbnail_preview_aspect_ratio_flexible'), ")"),
    recommendedSize: RECOMMENDED_ASSET_THUMBNAIL_SIZE,
    onClose: onClose,
    children: [/*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "m",
        children: t('thumbnail_preview_asset_card')
      }), /*#__PURE__*/_jsx(CollectionGrid, {
        children: /*#__PURE__*/_jsx(CollectionGridItem, {
          children: /*#__PURE__*/_jsx(VerticalCard, {
            icon: icon,
            id: "vertical-card-preview-".concat(id),
            imageSource: getPictureUrl({
              id: thumbnailId,
              dimensions: DIMENSIONS.VERTICAL_CARD
            }),
            title: name,
            subtitle: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(TypeIcon, {
                name: icon
              }), type]
            }),
            description: description,
            compactLayoutBreakpoint: "m"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "m",
        children: t('thumbnail_preview_asset_list_card')
      }), /*#__PURE__*/_jsx(HorizontalCard, {
        icon: icon,
        id: "horizontal-card-preview-".concat(id),
        imageSource: getPictureUrl({
          id: thumbnailId,
          dimensions: DIMENSIONS.HORIZONTAL_CARD
        }),
        title: name,
        subtitle: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TypeIcon, {
            name: icon
          }), type]
        }),
        description: description,
        compactLayoutBreakpoint: "m"
      })]
    }), /*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "m",
        children: t('thumbnail_preview_size_shared_asset_billboard')
      }), /*#__PURE__*/_jsx(Billboard, {
        icon: icon,
        id: "billboard-preview-".concat(id),
        imageSource: getPictureUrl({
          id: thumbnailId,
          dimensions: DIMENSIONS.BILLBOARD
        }),
        title: name,
        subtitle: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TypeIcon, {
            name: icon
          }), type]
        }),
        description: description
      })]
    })]
  });
}
export default AssetThumbnailPreview;